<template>
	<div>
		<v-container align="center" justify="center" class="pa-5">
			<v-list-item three-line>
				<v-list-item-content>
					<v-list-item-title class="mb-1 text-center text-wrap"><h1>Preferred locations</h1></v-list-item-title>
				</v-list-item-content>
			</v-list-item>
		</v-container>

		<v-card-text align="center" justify="center" class="justify-center text-left pl-5 pr-5 pb-0 pm-0 text-wrap">
			<v-row align="start" justify="center">
				<v-col align="start" justify="center" cols="6" sm="12" md="6">
					<v-select
						v-model="provinceSelected"
						outlined
						:items="province_computed"
						persistent-hint
						label="Where is your home province?"
						@change="filterLocations()"
					></v-select>
				</v-col>
				<v-col align="start" justify="center" cols="6" sm="12" md="6">
					<v-select
						v-model="locations"
						:rules="locationsRules"
						outlined
						:items="region_computed"
						multiple
						chips
						deletable-chips
						:disabled="provinceSelected ? false : true"
						:label="provinceSelected ? 'City/District/Regions for work' : 'Please select a province.'"
						persistent-hint
						:hint="provinceSelected ? 'Multiple regions are accepted' : ''"
					></v-select>
				</v-col>
			</v-row>

			<v-row
				><v-col> <v-text-field v-model="streetAddress" label="Street address" outlined :rules="streetAddressRules"></v-text-field> </v-col
			></v-row>

			<v-row>
				<v-col>
					<v-select
						v-model="province_region"
						outlined
						:items="region_computed"
						:disabled="provinceSelected ? false : true"
						:label="provinceSelected ? 'Enter your home City/District/Region' : 'Please select province above'"
						:rules="regionRules"
					></v-select>
				</v-col>
			</v-row>

			<v-row
				><v-col> <v-text-field v-model="suburb" label="Enter suburb" outlined :rules="suburbRules"></v-text-field> </v-col
			></v-row>

			<v-row align="center" justify="center">
				<v-col align="center" justify="center" :cols="7">
					<DistinctYesNo :initial.sync="willing_to_travel" :errors="willing_to_travel_errors" @input="changeWTT"
						>Are you willing to travel for a long term assignment?</DistinctYesNo
					>
				</v-col>
			</v-row>
		</v-card-text>
	</div>
</template>

<script>
import { bus } from '@/main';
import axios from 'axios';
import store from '@/store';

import DistinctYesNo from '@/components/custom/YesNo.vue';
import { provinceRegionPairs } from '@utils';

export default {
	components: {
		DistinctYesNo,
	},
	data: () => ({
		keyboi: 0,
		inarea: false,
		willing_to_travel: false,
		willing_to_travel_errors: false,
		will_specify_locations: false,
		distance: 50,
		step: 'locations-step',

		location_sets: [],

		locations: [],
		locationsRules: [v => (!!v && v.length > 0) || 'Please select at least one region'],
		provinceSelected: null,

		province_region: null,
		province_regions: provinceRegionPairs,

		streetAddress: null,
		streetAddressRules: [v => !!v || 'Required'],

		province: null,
		provinceRules: [v => !!v || 'Required'],

		region: null,
		regionRules: [v => !!v || 'Required'],

		suburb: null,
		suburbRules: [v => !!v || 'Required'],
	}),
	computed: {
		user() {
			return store.getters.user;
		},
		user_address() {
			return 'address' in this.user ? this.user.address : false;
		},
		region_computed() {
			let result = [];
			if (this.provinceSelected) {
				this.province_regions.forEach(set => {
					if (this.provinceSelected == set.province) {
						result.push({ text: set.region, value: set });
					}
				});
			}
			return result;
		},
		province_computed() {
			let result = [];
			this.province_regions.forEach(set => {
				if (!result.some(value => value == set.province)) {
					result.push(set.province);
				}
			});
			return result;
		},
		users_location() {
			return this.user_address
				? {
						text: this.user_address.region,
						value: { province: this.user_address.province, region: this.user_address.region },
				  }
				: false;
		},
	},
	mounted() {
		window.scrollTo(0, 0);
		bus.$on('intent:submit-forms', data => {
			this.postToBackend(data);
		});
		this.$nextTick(() => {
			const { street, province, region, suburb } = this.user_address;

			this.streetAddress = street;
			this.suburb = suburb;
			this.province_region = { province, region };
			this.region = region;
		});

		const {
			willing_to_travel,
			locations = [],
			address: { province, region },
		} = store.getters.user;
		this.willing_to_travel = willing_to_travel ? 'yes' : 'no';

		this.provinceSelected = this.users_location.value.province;

		if (locations.length === 0) {
			this.locations.push({ province, region });
		}

		locations.forEach(location => {
			const [province, region] = location.split(',');
			if (this.provinceSelected && province === this.provinceSelected) {
				this.locations.push({ province, region });
			}
		});
	},
	beforeDestroy() {
		bus.$off('intent:submit-forms');
	},

	methods: {
		addLocation() {
			this.location_sets.push({
				region: false,
				province: false,
				provinceSelected: this.provinceSelected,
			});
		},
		filterLocations() {
			if (this.province_region.province !== this.provinceSelected) {
				this.province_region = '';
			}
			this.locations = this.locations.filter(({ province }) => province === this.provinceSelected);
		},
		changeWTT(a) {
			this.willing_to_travel = a;
		},
		checkStep(user) {
			const {
				address: { province, region, suburb, street },
			} = user;
			if (province && region && suburb && street && user.locations?.length > 0) {
				store.commit('SET_PROFILE_BUTTON_TO_POSITIVE', this.step);
				return true;
			} else {
				return false;
			}
		},
		postToBackend() {
			if (this.locations.length === 0) {
				this.locations = [];
				return;
			}
			if (!this.province_region.region) {
				return;
			}

			bus.$emit('update:spinning', true);

			const token = store.getters.jwtToken;
			const { short_bio = '', languages = [], id } = store.getters.user;

			let body = {
				short_bio,
				willing_to_travel: this.willing_to_travel == 'yes',
				languages,
				locations: this.locations.map(({ province, region }) => `${province},${region}`),
				address: {
					province: this.provinceSelected,
					region: this.province_region.region,
					suburb: this.suburb,
					street: this.streetAddress,
				},
			};

			const authHeader = { headers: { Authorization: token } };

			axios
				.put(store.getters.getAPI + '/professionals/aboutme', body, authHeader)
				.then(async response => {
					const { status, data } = response;
					bus.$emit('form-submitted', { form: this.name, status });
					if (status === 200) {
						const { willing_to_travel, locations } = body;
						await axios.put(`${store.getters.getAPI}/calendar/professional/availability/update-all/${id}`, { willing_to_travel, locations }, authHeader);
						store.commit('SET_USER', data.data); //refresh the users state.
						bus.$emit('intent:next-step', 'locations-step');
					}
				})
				.finally(() => {
					bus.$emit('update:spinning', false);
				});
		},
		getText() {
			return 'locations';
		},
	},
};
</script>
